import type { EntityAdapter } from '@ngrx/entity';
import type { Action } from '@ngrx/store';
import type {
  CompletedEntityState,
} from 'app/store/completed-entity-state/completed-entity-state';
import type { ExtensionOutput } from 'core/http/project/extension/extension.service';
import { createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import {
  initialCompletedEntityState,
} from 'app/store/completed-entity-state/completed-entity-state';
import * as ExtensionActions from './extensions.actions';

export interface ExtensionsState extends CompletedEntityState<ExtensionOutput> {}

const adapter: EntityAdapter<ExtensionOutput> = createEntityAdapter();

export const initialExtensionsState = adapter.getInitialState<ExtensionsState>(initialCompletedEntityState);

const reducer = createReducer(
  initialExtensionsState,
  on(ExtensionActions.saveExtensions, (state, { extensions }) => adapter.setAll(extensions, state)),
  on(ExtensionActions.markExtensionsLoaded, state => ({ ...state, loaded: true })),
  on(ExtensionActions.setLoading, (state, { value }) => ({ ...state, loading: value })),
  on(ExtensionActions.setError, (state, { value }) => ({ ...state, error: value })),
);

export function extensionsReducer(state: ExtensionsState | undefined, action: Action): ExtensionsState {
  return reducer(state, action);
}

export const {
  selectAll,
  selectEntities,
} = adapter.getSelectors();
